import { useState, FC } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.scss";
import "./taleo.scss";
import { Navbar } from "./components/Navbar/Navbar";
import { NavbarSticky } from "./components/Navbar/NavbarSticky";
import { Home } from "./components/Home/Home";
import { Dropdown } from "./components/Dropdown/Dropdown";
import { Footer } from "./components/Footer/Footer";
import { About } from "./components/About/About";
import { Contacts } from "./components/Contacts/Contacts";
import { ContractVehicles } from "./components/ContractVehicles/ContractVehicles";
import { Solutions } from "./components/Solutions/Solutions";
import { Careers } from "./components/Careers/Careers";
import { News } from "./components/News/News";
import { Contract_Schedule70 } from "./components/ContractVehicles/Schedule70/Contract_Schedule70";
import { SeaportNxG } from "./components/ContractVehicles/SeaportNxG/SeaportNxg";
import { CIO } from "./components/ContractVehicles/CIO/CIO";
import { ScrollToTop } from "./ScrollToTop";

export const App: FC = () => {
  let [dropdown, setDropdown] = useState(false);
  // let [isLoading, setIsLoading] = useState<boolean>(true);

  // useEffect(() => {
  //   setTimeout(() => setIsLoading(false), 5000);
  // });

  // if (isLoading) return <Loading />;
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Navbar setDropdown={setDropdown} />
        <NavbarSticky />
        <Dropdown dropdown={dropdown} setDropdown={setDropdown} />
        <Switch>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/contacts">
            <Contacts />
          </Route>
          <Route path="/solutions">
            <Solutions />
          </Route>
          <Route path="/careers">
            <Careers />
          </Route>
          <Route path="/contract-vehicles">
            <ContractVehicles />
          </Route>
          <Route path="/news">
            <News />
          </Route>
          <Route path="/schedule70">
            <Contract_Schedule70 />
          </Route>
          <Route path="/seaportNxG">
            <SeaportNxG />
          </Route>
          <Route path="/cio">
            <CIO />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </div>
  );
};
